import clsx from 'clsx';

import { Typography } from '@/components/ui/typography';

type CounterVariant = 'neutral' | 'brand';

export function Counter({
  count,
  variant = 'neutral',
}: {
  count: number;
  variant?: CounterVariant;
}) {
  return (
    <div
      className={clsx(
        'flex h-4 w-6 items-center justify-center rounded-full px-1',
        variant === 'brand' ? 'bg-fx-brand-600' : 'bg-fx-neutral-100',
      )}
    >
      <Typography
        variant="small1"
        className={clsx(
          '!font-medium',
          variant === 'brand' ? '!text-white' : '!text-fx-neutral-600',
        )}
      >
        {count}
      </Typography>
    </div>
  );
}
